import { createApiSaga } from '../sagaGenerator';
import { apiGet } from '../../middleware/api';

import {
  CHECK_USER_REQUEST,
  CHECK_USER_SUCCESS,
  CHECK_USER_FAILURE,
} from './loginReducer';

const checkUserSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/me', ...action }),
  requestType: CHECK_USER_REQUEST,
  successType: CHECK_USER_SUCCESS,
  failureType: CHECK_USER_FAILURE,
  silentFlashErrors: true,
});

export const loginSagas = [
  checkUserSaga,
];
